<template>
  <div>
    <v-toolbar flat>
      <v-btn flat to="/developer/broadcaster/release"> Releases</v-btn>
      <v-btn flat to="/developer/broadcaster/partial-release"> Partial Releases</v-btn>

      <v-btn flat to="/developer/broadcaster/init"> Init</v-btn>
      <v-btn flat to="/developer/broadcaster/test"> Test</v-btn>
      <v-btn flat to="/developer/broadcaster/tested"> Tested</v-btn>
      <v-btn flat to="/developer/broadcaster/released"> Released</v-btn>
      <v-btn flat to="/developer/broadcaster/rejected"> Rejected</v-btn>
      <v-btn flat to="/developer/broadcaster/archived"> Archived</v-btn>
    </v-toolbar>
    <div v-if="is_settings">

    <v-list two-line dense>
      <v-list-tile v-for="release in filtered_releases" @click.stop="open_release(release)">
        <v-list-tile-content style="min-width: 80px; max-width:80px;">
          <v-list-tile-title> {{release.id}}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-content style="min-width: 10px; max-width:100px;">
          <v-list-tile-title> {{release.os_version}}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-content style="min-width: 300px; max-width: 300px;">
          <v-list-tile-title> {{release.version}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-content style="min-width: 400px; max-width: 400px;">
          <v-list-tile-title> {{release.key}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-content style="min-width: 140px; max-width: 140px;">
          <v-list-tile-title> {{release.updated_at}}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-content style="">
          <v-list-tile-title> {{release.unit_ids}}</v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>

    </v-list>
    </div>
  <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';
import Vue from 'vue';
import BottomSheet from '../BottomSheet';

export default {
  props: ["type"],
  components: {
    ContentData,
    BottomSheet
  },
  data () {
    return {
      releases: []
    }
  },
  watch: {
    "$route" (newVal) {
      this.update_release_data();
    }
  },
  methods:{
    update_release_data () {
      var url = "content_list/" + this.list_id;
      var self = this;
      Vue.http.get(url).then((response) => {
        self.releases = response.body;
      }, (response) => {
      });
    },
    open_release(release) {
      this.$router.push("/developer/broadcaster/"+this.type+"/edit/" + this.list_id + "/data/" + release.id);
    }

  },
  computed: {
    filtered_releases() {
      var t = this.type || "release";
      var rels =  _.filter(this.releases, function(release) {
        if (release.status == t) return true;
        return false;
      });

      return _.sortBy(rels, function(rel) {
        return rel.id;
      });
    },
    is_settings() {
      if (this.settings.length > 0) {
        this.update_release_data();
        return true;
      }
      return false;
    },
    settings () {
      return SettingsModel.list("developer_config");
    },
    list_id() {
      return this.settings[0].value.broadcaster_list_id;
    }
  }
}
</script>